<template lang="html">
    <header class="app-header">
        <div class="header-desktop-left">
            <div class="header-branding">
                <a data-v-4358f9fa="" href="/" class="active">
                    <div>
                    <div v-if="clientLogo">
                        <img class='nav-logo' :src="clientLogo"/>
                    </div>
                    <div v-else >
                        <logo></logo>
                    </div>
                    </div>
                </a>
            </div>

        </div>
    </header>
</template>

<script>
    import logo from '../../assets/images/logo-acquire';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            logo
        },
        data () {
            return {
                clientLogo: null,
                subdomain: null
            }
        },
        computed: {
            ...mapGetters(['getLogo', 'getFavicon']),
        },
        mounted() {
            this.subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : null;
            const favicon = document.getElementById("favicon");
            const faviconApple = document.getElementById("favicon-apple");
            const vue = this;               
            this.$store.dispatch('logos', this.subdomain).then(() => {
                let logoUrl = vue.$store.state.logo;
                let faviconUrl = vue.$store.state.favicon;
                this.clientLogo = logoUrl ? logoUrl : null;
                if (faviconUrl) {
                    favicon.href = faviconUrl;
                    faviconApple.href = faviconUrl;
                }                
            });     
        }
    }
</script>

<style lang="scss" scoped>
    @import './src/assets/sass/vue';
    
</style>
